import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { RootScopeDeclare } from 'src/app/core/rootscope-declare';
import { environment } from '../../../../environments/environment';
import { CommonUtil } from '../../../core/Utils/common-util';

@Component({
  selector: 'app-lfod-modal',
  templateUrl: './lfod-modal.component.html',
  styleUrls: ['./lfod-modal.component.scss']
})
export class LfodModalComponent implements OnInit {
  cloudBasePath: string;
  rootScopeData: RootScopeDeclare;
  
  @Output() onClose:EventEmitter<any> = new EventEmitter();
  
  constructor (public commonUtil: CommonUtil) { }

  ngOnInit() {
    this.cloudBasePath = environment.cloudBasePath;
    this.rootScopeData = this.commonUtil.rootScopeData;
  }

  close(){
    this.onClose.emit();
  }
}

